import { Routes } from '@angular/router';
import { AuthenticationGuard } from '@softline/auth';
import { SOFTLINE_PERMISSION_BELEGLESER } from './belegleser.shared';
import { JobRepository } from './repositories/job.repository';
import { FieldCatalogService } from './services/field-catalog.service';
import { JobService } from './services/job.service';

export const belegleserRoutes: Routes = [
  {
    path: 'belegleser',
    canActivate: [AuthenticationGuard],
    data: { permission: SOFTLINE_PERMISSION_BELEGLESER },
    // Module-scoped, not per page: the job poll survives the upload → review navigation,
    // and a loaded field catalog serves every job of the session.
    providers: [JobRepository, JobService, FieldCatalogService],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'upload' },
      {
        path: 'upload',
        loadComponent: () =>
          import('./pages/upload/upload.page').then((m) => m.UploadPage),
      },
      {
        path: ':jobId',
        loadComponent: () =>
          import('./pages/review/review.page').then((m) => m.ReviewPage),
      },
    ],
  },
];
